import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import * as styles from './TierProgress.css';

const cx = classNames.bind(styles);

const TierProgress = ({ tier, completed, limit }) => {
    const isMember = tier === 'Member';
    const progressMessage = isMember
        ? 'Level Up to Unlock Challenges'
        : `${completed} of ${limit} Challenges Completed`;

    return (
        <div className={cx('tierProgress')}>
            <span className={cx('tierIcon')}>{tier.toUpperCase()}</span>
            <div className={cx('separator')} />
            <p className={cx('progressMessage')}>{progressMessage}</p>
        </div>
    );
};

TierProgress.propTypes = {
    tier: PropTypes.string.isRequired,
    completed: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
};

export default TierProgress;
